import React, { useMemo } from 'react';
import ZoomVideo from '@zoom/videosdk';

import EventPageView from './EventPageView';
import { useMytaverseEvent } from '../../../../../modules/dashboard/providers';
import { useChatHandlers } from '../../../../../modules/dashboard/hooks/channel';
import { ZoomProvider } from '../../../../../modules/dashboard/components/DashboardContent/Zoom/ZoomProvider';
import { PocAiProvider } from '../../../../../modules/dashboard/components/PocAi';
import { useIdleTimerLogout } from './hooks';

const EventPage = () => {
  const {
    showControls,
    currentEvent,
    streamChatToken,
    openAdminSettingsModal,
    gameReadyToPlay,
    streamingProvider,
    isHideWebUI,
  } = useMytaverseEvent();

  const zmClient = useMemo(() => {
    return ZoomVideo.createClient();
  }, []);

  useChatHandlers({ currentEvent, streamChatToken });
  useIdleTimerLogout();

  return (
    <ZoomProvider zmClient={zmClient as never}>
      <PocAiProvider>
        <EventPageView
          showControls={showControls && !isHideWebUI.flag}
          openAdminSettingsModal={openAdminSettingsModal}
          gameReadyToPlay={gameReadyToPlay}
          streamingProvider={streamingProvider}
        />
      </PocAiProvider>
    </ZoomProvider>
  );
};

export default EventPage;
